var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "audible__c",
    x1: 3.367,
    x2: 28.633,
    y1: 3.367,
    y2: 28.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC565"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "audible__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "audible__d",
    width: 27.628,
    height: 17.69,
    x: 2.408,
    y: 7.346,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_663_2920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_663_2920",
    result: "shape"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#audible__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "audible__b",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c12.357 0 16 3.643 16 16s-3.643 16-16 16S0 28.357 0 16 3.643 0 16 0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#audible__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#audible__c)",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#audible__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.222 21.895 12.814-7.926v2.14l-12.814 7.926L3.408 16.11v-2.14l12.814 7.926Zm-.004-9.91a8.32 8.32 0 0 0-6.913 3.663l.011.001a9 9 0 0 1 .308-.266c3.596-2.95 8.787-2.303 11.623 1.438l1.888-1.167a8.32 8.32 0 0 0-6.917-3.67Zm0 3.639a4.638 4.638 0 0 0-3.783 1.942 4.008 4.008 0 0 1 2.299-.741c1.377 0 2.612.729 3.46 1.885l1.82-1.125h.002a4.637 4.637 0 0 0-3.798-1.961Zm-8.66-3.197c5.275-4.134 12.741-3.026 16.718 2.463l.027.04 1.953-1.204a12.003 12.003 0 0 0-10.037-5.38 11.98 11.98 0 0 0-10.033 5.373c.397-.413.91-.931 1.371-1.292Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudible);
export default __webpack_public_path__ + "static/media/audible.aa993a40dc12332c2432b19d768bd7c3.svg";
export { ForwardRef as ReactComponent };